export default {"src":"/_next/static/image/public/images/flags/flag_263.3d96abd97817fc23c00395d0c751e8ea.svg","height":16,"width":24};